module.exports = __webpack_public_path__ + "img/744.87d47790.jpg";